import { render, staticRenderFns } from "./Bun.vue?vue&type=template&id=4b1d5003"
import script from "./Bun.vue?vue&type=script&lang=js"
export * from "./Bun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports